// For in-person assignment the test is created before the device is assigned, so a failure
// may leave the test in place. Claiming it was not added sends the HCP away from a test that
// exists and needs a device, and they re-book it.
export function confirmTestFailureMessage(hcpAssignmentToken) {
    return hcpAssignmentToken
        ? 'Something went wrong assigning the device. Check the patient\'s tests before trying again, as the test may already have been created.'
        : 'Something went wrong. The test was not added'
}
